import { render, staticRenderFns } from "./KurccVerificationsPage.vue?vue&type=template&id=7f062288&"
import script from "./KurccVerificationsPage.vue?vue&type=script&lang=js&"
export * from "./KurccVerificationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports